import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "panel-frame border-primary-50" }
const _hoisted_2 = { class: "panel-frame-header" }
const _hoisted_3 = { class: "h3 mb-s6" }
const _hoisted_4 = { class: "panel-frame-close-icon" }
const _hoisted_5 = { class: "mr-s1" }

import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { STEP_STATUS, StepInfo } from '@/components/stepper/stepper.types';
import Step from '@/components/stepper/Step.vue';
import Icon from '@/components/icon/Icon.vue';
import { computed } from 'vue';
import ControlIcon from '@/components/icon/ControlIcon.vue';
import { useEasyModeForm } from './portfolio/liquidity-management/easy-mode/composables/useEasyModeForm';
import { useEasyModeAddLiquiditySteps } from '@/store/modules/portfolios/easy-mode/add-liquidity/useEasyModeAddLiquiditySteps';
import { useEasyModeAddLiquidity } from '@/store/modules/portfolios/easy-mode/add-liquidity/useEasyModeAddLiquidity';
import { useEasyModeWithdrawSteps } from '@/store/modules/portfolios/easy-mode/withdraw/useEasyModeWithdrawSteps';
import { useEasyModeWithdraw } from '@/store/modules/portfolios/easy-mode/withdraw/useEasyModeWithdraw';


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioSteps',
  props: {
    action: null
  },
  emits: ["onClose"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'onClose'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  action: string;
}





const { t, te } = useI18n();
const { state } = useStore();
const { easyModeForm } = useEasyModeForm();
const { $reset: resetEasyModeAddLiquidityForm } = useEasyModeAddLiquidity();
const { $reset: resetEasyModeWithdrawForm } = useEasyModeWithdraw();
const { addLiquiditySteps, $reset: resetAddLiquiditySteps } = useEasyModeAddLiquiditySteps();
const { withdrawSteps, $reset: resetWithdrawSteps } = useEasyModeWithdrawSteps();

const header = computed(() =>
  t(`portfolio.steps.header.${props.action}`, {
    portfolioName: easyModeForm.portfolio.name,
  }),
);
const portfolioSteps = computed(() => {
  if (easyModeForm.action === 'addLiquidity') {
    return addLiquiditySteps.steps;
  }

  return withdrawSteps.steps;
});

const isError = computed(() =>
  portfolioSteps.value.some((step: StepInfo) => step.status === STEP_STATUS.ERROR),
);

const isSuccessful = computed(() =>
  portfolioSteps.value.every((step: StepInfo) => step.status === STEP_STATUS.SUCCESS),
);

const infoMessage = computed(() => {
  const currentActiveIndx = portfolioSteps.value.findIndex(
    step => step.status === STEP_STATUS.ACTIVE,
  );
  const msgType = portfolioSteps.value[currentActiveIndx]?.type ?? 'default';
  return te(`portfolio.steps.infoMessage.${msgType}`)
    ? t(`portfolio.steps.infoMessage.${msgType}`)
    : t('wrappedContract.steps.infoMessage.default');
});

function resetForm() {
  const reset =
    easyModeForm.action === 'addLiquidity'
      ? resetEasyModeAddLiquidityForm
      : resetEasyModeWithdrawForm;
  reset();
}

function resetSteps() {
  const reset =
    easyModeForm.action === 'addLiquidity' ? resetAddLiquiditySteps : resetWithdrawSteps;
  reset();
}

function onCloseSteps() {
  resetForm();
  resetSteps();
  emits('onClose');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(header)), 1),
        _createElementVNode("div", _hoisted_4, [
          (_unref(isError) || _unref(isSuccessful))
            ? (_openBlock(), _createBlock(ControlIcon, {
                key: 0,
                name: "close",
                onClick: onCloseSteps
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["flex p-s3 mb-s3", _unref(isError) ? 'panel-message-error' : 'panel-message-info'])
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(Icon, {
            name: "error",
            size: "16"
          })
        ]),
        _createElementVNode("div", null, _toDisplayString(_unref(isError) ? _unref(t)('wrappedContract.steps.infoMessage.error') : _unref(infoMessage)), 1)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["steps", _unref(state).layout.isMobile ? 'steps-column' : 'steps-row'])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(portfolioSteps), (step, index) => {
          return (_openBlock(), _createBlock(Step, {
            key: index,
            number: index + 1,
            name: step.name!,
            status: step.status
          }, null, 8, ["number", "name", "status"]))
        }), 128))
      ], 2)
    ])
  ]))
}
}

})